import Popup from "../../../components/base/popup";
import {AnalyticsService} from "../../../services/analytics-service";

export default class CourseHelpPopup extends Popup {
    constructor(props) {
        super(props);

        this.$root = document.getElementById(props.id);

        this.cookieName = props.cookieName;
        this.cookie = costorage.get(this.cookieName);
        this.dataLayerEvent = props.dataLayerEvent;

        if (this.$root && !this.cookie) {
            this.init();
        }
    }

    init() {
        super.show();
        super.init();
    }

    hide() {
        super.hide();

        if (this.dataLayerEvent != null) {
            AnalyticsService.sendEvent(this.dataLayerEvent);
        }

        this.setCookie();
    }

    setCookie() {
        costorage.set(this.cookieName, 1, { expires: 30 * 24 * 60 * 60, path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' })
    }
}